export default "__VITE_ASSET__C6yyu5T3__"